import { useState } from 'react';
import { useRouter } from 'next/router';

import { OutlinedInput, InputAdornment } from '@mui/material';

import FilterDropdown from '@core/components/filterdropdown/FilterDropdown';
import JobAlert from './jobalert/JobAlert';

import { JOB_FILTERS } from './jobsFilterOptions';
import { isUserLoggedIn } from 'utils/authentication';

import SearchIcon from '@core/assets/icons/search-normal.svg';
import LocationIcon from 'assets/icons/location-icon-bold.svg';
import { Bookmark2 } from 'iconsax-react';

import classes from './JobsFiltersForm.module.scss';

const JobsFiltersForm = ({ values, setValues, toast, expandedFilters = false }) => {
	const router = useRouter();
	const isAuthenticated = isUserLoggedIn();
	const [searchKeyword, setSearchKeyword] = useState(values?.search_keyword || '');
	const [locationKeyword, setLocationKeyword] = useState(values?.location || '');

	const isSavedJobsActive = values?.favorite === 'true';

	const filterChangeHandler = (name, newValue) => {
		setValues((prevState) => ({ ...prevState, [name]: newValue }));
	};

	const submitKeywordsHandler = () => {
		setValues((prevState) => ({
			...prevState,
			search_keyword: searchKeyword,
			location: locationKeyword
		}));
	};

	// inside the mobile modal nothing is applied until "Apply Filters", so the typed
	// keywords are kept in the values on every change instead of on Enter only
	const keywordChangeHandler = (newValue, key, setKeyword) => {
		setKeyword(newValue);
		if (expandedFilters) {
			setValues((prevState) => ({ ...prevState, [key]: newValue }));
		}
	};

	const savedJobsHandler = () => {
		if (!isAuthenticated) {
			router.push('/login?next=' + router.asPath);
			return;
		}
		filterChangeHandler('favorite', isSavedJobsActive ? '' : 'true');
	};

	return (
		<div className={`${classes['jobs-filters-form']} w-100`}>
			<div className={classes['top-row']}>
				<div className={classes['keyword-inputs']}>
					<OutlinedInput
						id="search_keyword"
						name="search_keyword"
						data-testid="search_keyword"
						value={searchKeyword}
						onChange={(e) => keywordChangeHandler(e.target.value, 'search_keyword', setSearchKeyword)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								submitKeywordsHandler();
							}
						}}
						className="w-100"
						placeholder="Search jobs, keywords, companies"
						startAdornment={
							<InputAdornment position="start">
								<SearchIcon />
							</InputAdornment>
						}
					/>
					<OutlinedInput
						id="location"
						name="location"
						data-testid="location"
						value={locationKeyword}
						onChange={(e) => keywordChangeHandler(e.target.value, 'location', setLocationKeyword)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								submitKeywordsHandler();
							}
						}}
						className="w-100"
						placeholder="Location (or Remote)"
						startAdornment={
							<InputAdornment position="start">
								<LocationIcon />
							</InputAdornment>
						}
					/>
				</div>
				<div className={classes['actions']}>
					<button
						type="button"
						onClick={savedJobsHandler}
						data-testid="saved-jobs"
						className={`${classes['saved-jobs']} ${isSavedJobsActive ? classes['active'] : ''}`}>
						<Bookmark2 size={18} variant={isSavedJobsActive ? 'Bold' : 'Linear'} />
						Saved Jobs
					</button>
					<JobAlert toast={toast} />
				</div>
			</div>
			<div className={`${classes['filters-row']} ${expandedFilters ? classes['expanded'] : ''}`}>
				{JOB_FILTERS.map((filter) => (
					<FilterDropdown
						key={filter.name}
						name={filter.name}
						label={filter.label}
						type={filter.type}
						options={filter.options}
						value={values?.[filter.name] || ''}
						onChange={filterChangeHandler}
						expanded={expandedFilters}
					/>
				))}
			</div>
		</div>
	);
};

export default JobsFiltersForm;
